import { useEffect, useRef } from "react";

import HexLattice from "../components/HexLattice";
import { ArrowIcon } from "../components/Icons";
import { CTA } from "../data/content";
import { magnetic, revealUp } from "../lib/motion";
import { scrollToSection } from "../lib/useSmoothScroll";
import "./Cta.css";

export default function Cta({ lenisRef }) {
  const panelRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const cleanups = [
      revealUp([panelRef.current], { y: 44, stagger: 0, start: "top 90%" }),
      magnetic(buttonRef.current, { strength: 0.22, scale: 1.04 }),
    ];
    return () => cleanups.forEach((fn) => fn());
  }, []);

  return (
    <section className="section ilab-cta" aria-labelledby="cta-title">
      <div className="container">
        <div className="ilab-cta__panel on-blue" ref={panelRef}>
          <HexLattice variant="onBlue" radius={54} className="hex-lattice--cta" />

          <img
            className="ilab-cta__shape"
            src="/assets/shape/cta-shape.png"
            alt=""
            aria-hidden="true"
            width="616"
            height="616"
            loading="lazy"
          />

          <h2 className="ilab-cta__title" id="cta-title">
            {CTA.title}
          </h2>

          <a
            className="ilab-cta__button"
            href={CTA.action.href}
            ref={buttonRef}
            onClick={(event) => {
              event.preventDefault();
              scrollToSection(lenisRef?.current, CTA.action.href, -90);
            }}
          >
            <span>{CTA.action.label}</span>
            <ArrowIcon width="18" height="18" />
          </a>
        </div>
      </div>
    </section>
  );
}
